export const GET_FIRST_LUTEAL_PHASE_REQUEST = "@@ddw.herdnet.sandbox.hnadvice/GET_FIRST_LUTEAL_PHASE_REQUEST";
export const GET_FIRST_LUTEAL_PHASE_SUCCESS = "@@ddw.herdnet.sandbox.hnadvice/GET_FIRST_LUTEAL_PHASE_SUCCESS";
export const GET_FIRST_LUTEAL_PHASE_FAILURE = "@@ddw.herdnet.sandbox.hnadvice/GET_FIRST_LUTEAL_PHASE_FAILURE";
